/**
 * Traduccion de errores de la API al idioma activo.
 *
 * El servidor manda un codigo estable, nunca texto de interfaz, asi que el
 * mensaje se compone aqui. Si aparece un codigo desconocido, se cae a un
 * mensaje generico en lugar de mostrar el codigo crudo al usuario.
 */

import { useTranslation } from 'react-i18next';
import { ErrorRed, ErrorRespuesta } from '@/api/cliente.ts';

export function useMensajeError(): (error: unknown) => string {
  const { t } = useTranslation();

  return (error: unknown): string => {
    if (error instanceof ErrorRed) return t('errors.xarxa');

    if (error instanceof ErrorRespuesta) {
      const clave = `errors.${error.codigo}`;
      const traducido = t(clave, { ...(error.contexto ?? {}) });
      return traducido === clave ? t('errors.error_interno') : traducido;
    }

    return t('errors.error_interno');
  };
}

interface Props {
  error: unknown;
  alReintentar?: () => void;
}

export function MensajeError({ error, alReintentar }: Props) {
  const { t } = useTranslation();
  const mensaje = useMensajeError()(error);

  return (
    <div role="alert" className="aviso-error">
      {/*
        El titulo en rojo y el detalle en tinta. Antes el bloque entero iba en
        rojo, y un parrafo de tres lineas en rojo cuesta de leer justo cuando
        hace falta leerlo bien.
      */}
      <p className="font-semibold text-roig-700">{t('errors.titol')}</p>
      <p className="mt-1">{mensaje}</p>
      {alReintentar ? (
        <button type="button" onClick={alReintentar} className="boton-secundario mt-3">
          {t('app.reintentar')}
        </button>
      ) : null}
    </div>
  );
}
